import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';

export const slide = () => {
  return (
    <Slide notes="Workshop agenda overview" transition="fade" networkBackground="full">
      <div className="relative z-10 flex flex-col justify-center h-full px-24 py-8 text-left slide-scale-75">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="title">Workshop Agenda</h2>
        </WebContent>

        <div className="space-y-4 mt-8">
          <WebContent
            animation={{
              type: 'fade',
              delay: 1000,
              duration: 800,
            }}
          >
            <p>• ChatGPT Advanced Features</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 1500,
              duration: 800,
            }}
          >
            <p>• Claude voor Coderen & Schrijven</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p>• Midjourney Geavanceerde Technieken</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 2500,
              duration: 800,
            }}
          >
            <p>• Pauze (10 minuten)</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 3000,
              duration: 800,
            }}
          >
            <p>• Cursor IDE voor Development</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 3500,
              duration: 800,
            }}
          >
            <p>• Sora Video Generatie</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 4000,
              duration: 800,
            }}
          >
            <p>• ElevenLabs Voice</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 4500,
              duration: 800,
            }}
          >
            <p>• Q&A / Tips</p>
          </WebContent>
        </div>
      </div>
    </Slide>
  );
};
